import * as tenantLib from './tenant_lib'

export type TenantsLike = tenantLib.TenantLike[]

export const getCurrentTenants = <T extends tenantLib.TenantLike>(
  tenants: T[],
  date: string | null,
  exceptId: number | null,
): T[] => {
  return tenants.filter(
    (tenant) => tenantLib.isCurrent(tenant, date) && tenant.id !== exceptId,
  )
}

export const getFutureTenants = <T extends tenantLib.TenantLike>(
  tenants: T[],
  date: string | null,
  exceptId: number | null,
): T[] => {
  return tenants.filter(
    (tenant) => tenantLib.isFuture(tenant, date) && tenant.id !== exceptId,
  )
}

export const getPastTenants = <T extends tenantLib.TenantLike>(
  tenants: T[],
  date: string | null,
  exceptId: number | null,
): T[] => {
  return tenants.filter(
    (tenant) => tenantLib.isPast(tenant, date) && tenant.id !== exceptId,
  )
}
